/**
 * useContainers
 */

import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';

const {
    useQuery,
} = ApolloLib;
const {
    GET_CONTAINERS,
} = Queries;

const useContainers = (ids, options = {}) => {

    const {
        ssr = true,
        skip = false,
        idType = 'NAME',
    } =  options;

    const {
        loading,
        error,
        data,
    } = useQuery(
        GET_CONTAINERS,
        {
            variables: {
                ids,
                idType,
            },
            ssr,
            skip,
        }
    );

    return {
        loading,
        data,
        error,
    };

};

export default useContainers;
